<div class="portals-layout">
  <ion-segment mode="md" class="sticky-tabs">
    <ion-segment-button
      value="/dashboard/settings/portals/internal"
      routerLink="/dashboard/settings/portals/internal"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>Internal Customer Portal</ion-label>
    </ion-segment-button>
    <ion-segment-button
      value="/dashboard/settings/portals/external"
      routerLink="/dashboard/settings/portals/external"
      routerLinkActive="segment-button-checked"
    >
      <ion-label>External Customer Portal</ion-label>
    </ion-segment-button>
  </ion-segment>
  <ion-content class="portals-content">
    <router-outlet></router-outlet>
  </ion-content>
</div>
